import React, { createContext, useContext, useEffect, useState } from 'react'
import { onAuthStateChanged } from 'firebase/auth'
import { auth } from '../firebase/firebase'
import { usersService } from '../services/usersService'

const AuthContext = createContext(null)

export const useAuth = () => useContext(AuthContext)

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null)
  const [userProfile, setUserProfile] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      // Anonymous sessions exist only for public likes (NewsFeed, PrayerWall…) — not an admin login.
      const adminUser = user && !user.isAnonymous ? user : null
      setCurrentUser(adminUser)
      try {
        setUserProfile(adminUser ? await usersService.getUserProfile(adminUser.uid) : null)
      } catch {
        setUserProfile(null) // denied / offline — the whole site waits on `loading`, never leave it stuck
      } finally {
        setLoading(false)
      }
    })
    return unsubscribe
  }, [])

  return (
    <AuthContext.Provider value={{ currentUser, userProfile, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  )
}
